let SensorsSdk = require('sa-sdk-javascript');
const getQueryStringValue = (key:string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key);
}
const REACT_APP_NEW_SENSOR = process.env.REACT_APP_NEW_SENSOR
export const sensors = () => {
  let guid = getQueryStringValue('guid');
  SensorsSdk.init({
    server_url: `https://miaotouxinxi.datasink.sensorsdata.cn/sa?project=${REACT_APP_NEW_SENSOR}&token=a51c0fba683994e6`,
    app_js_bridge:true, // app 和 h5 数据打通
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      collect_tags:{
        div : true,
        span: true,
        img: true,
      },
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect'
    }
  });
  SensorsSdk.use('SiteLinker',
    {
      linker: [
        { part_url: 'https://applet-app-dev.miotech.com', after_hash: false },
        { part_url: 'https://applet-app.miotech.com', after_hash: false },
      ],
      // 该配置设置为 true 后，如果从已登录的页面跳转过来，即使当前网页已经登录，当前网页仍然会以之前网页的登录 id 再次登录。
      re_login: true
    }
  );
  SensorsSdk.quick('autoTrack'); //用于采集 $pageview 事件。
  SensorsSdk.identify(guid, true)
  SensorsSdk.bind("$identity_login_id", guid)
}
